let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("diW3e")).then(() => parcelRequire('baehV'));